<section class="visualizar-questionario-modal__section">
  <h3 class="visualizar-questionario-modal__section-title">1. Informações gerais</h3>
  <p class="visualizar-questionario-modal__value">
    Tipo de Questionário:
    <span data-testid="visualizar-questionario-tipo">{{ questionario().tipo }}</span>
  </p>
  <p class="visualizar-questionario-modal__value">
    Nome: <span data-testid="visualizar-questionario-nome">{{ questionario().nome }}</span>
  </p>
</section>

<section class="visualizar-questionario-modal__section">
  <h3 class="visualizar-questionario-modal__section-title">2. Perguntas</h3>
  @if (questionario().perguntas.length === 0) {
    <p class="questionario-empty-state" data-testid="visualizar-questionario-perguntas-empty">
      Nenhuma pergunta adicionada.
    </p>
  } @else {
    @for (pergunta of questionario().perguntas; track $index; let i = $index) {
      <div class="visualizar-questionario-modal__pergunta" data-testid="visualizar-questionario-pergunta">
        <p class="visualizar-questionario-modal__pergunta-texto">
          {{ i + 1 }}. {{ pergunta.texto }}
        </p>
        <ul class="questionario-alternativas">
          @for (alternativa of pergunta.alternativas; track $index) {
            <li class="questionario-alternativa" data-testid="visualizar-questionario-alternativa">
              <span class="questionario-alternativa__marcador" aria-hidden="true"></span>
              <span class="questionario-alternativa__texto">{{ alternativa.texto }}</span>
              <span class="questionario-alternativa__pontos">{{ alternativa.pontos }} pts</span>
            </li>
          }
        </ul>
      </div>
    }
  }
</section>

<section class="visualizar-questionario-modal__section">
  <h3 class="visualizar-questionario-modal__section-title">3. Associe o perfil</h3>
  @if (questionario().perfis.length === 0) {
    <p class="questionario-empty-state" data-testid="visualizar-questionario-perfis-empty">
      Nenhum perfil associado.
    </p>
  } @else {
    <div class="questionario-grid-row questionario-grid-row--perfil questionario-grid-row--head">
      <span class="questionario-col-label">Perfil</span>
      <span class="questionario-col-label">Pontuação mínima</span>
      <span class="questionario-col-label">Pontuação máxima</span>
    </div>
    @for (perfil of questionario().perfis; track $index) {
      <div class="questionario-grid-row questionario-grid-row--perfil" data-testid="visualizar-questionario-perfil">
        <span>{{ perfil.nomePerfil }}</span>
        <span>{{ perfil.pontuacaoMinima }}</span>
        <span>{{ perfil.pontuacaoMaxima }}</span>
      </div>
    }
  }
</section>
